import React from 'react';
import { formatDisplayDate } from '../../../utils';

export interface DateTimeCellProps {
  date: string;
  timeRange?: string;
  /** Makes the cell an interactive trigger (e.g. opening a fulfillment drawer). Omit to render a plain, non-interactive cell — AllOrdersTable's date cell relies on this default. */
  onClick?: () => void;
  /** Reflected as `aria-expanded` on the trigger opened by `onClick`; ignored when `onClick` is omitted. */
  isOpen?: boolean;
}

export const DateTimeCell: React.FC<DateTimeCellProps> = ({ date, timeRange, onClick, isOpen }) => {
  const content = (
    <>
      {formatDisplayDate(date, { includeYear: true })}
      {timeRange ? ` • ${timeRange}` : ''}
    </>
  );

  if (!onClick) {
    return <span className="sui-whitespace-nowrap sui-text-sm sui-text-subtle">{content}</span>;
  }

  return (
    <button
      type="button"
      onClick={onClick}
      aria-haspopup="dialog"
      aria-expanded={Boolean(isOpen)}
      className="sui-whitespace-nowrap sui-text-sm sui-text-subtle sui-underline"
    >
      {content}
    </button>
  );
};
